// src/components/WordCounter/WordCounter.tsx
import React, { FC, memo } from 'react';
import './WordCounter.less';

interface WordCounterProps {
  current: number;
  total: number;
  className?: string;
}

export const WordCounter: FC<WordCounterProps> = memo(({ current, total, className = '' }) => {
  if (total <= 1) {
    return null;
  }

  return (
    <div className="word-counter-wrapper">
      <p className={`word-counter ${className}`.trim()}>
        {current} / {total}
      </p>
    </div>
  );
});

WordCounter.displayName = 'WordCounter';
export default WordCounter;
